import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import ContractRowDumb from './row-dumb';
import RateConversionRowDumb from '../../dummy-account/rate-conversion-row-dumb';

const propTypes = {
  selectedContracts: PropTypes.array,
  hoveringOverContractId: PropTypes.string,
  actions: PropTypes.object,
  showFolder: PropTypes.bool,
  contract: PropTypes.object,
  drafts: PropTypes.array,
  templates: PropTypes.array,
  isSingleLoc: PropTypes.bool,
};

class ContractRow extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { contract } = this.props;
    if (
      window.location.href.indexOf('/contract-list/rate-conversion') > -1
      || (!contract.isLatest && ['opt-in', 'opt-out'].indexOf(contract.rateConversionSetting) > -1)
    ) {
      return (
        <RateConversionRowDumb
          {...this.props}
          inSearchResult={window.location.href.indexOf('/contract-list/search') > -1}
        />
      );
    }
    return (<ContractRowDumb {...this.props}/>);
  }
}

ContractRow.propTypes = propTypes;

const mapStateToProps = ({ contracting, user, config }) => ({
  apiUrl: config.get('apiUrl'),
  drafts: contracting.templateList.get('drafts').toJS(),
  templates: contracting.templateList.get('templates').toJS(),
  hoveringOverContractId: contracting.contractList.get('hoveringOverContractId'),
  isShellAccount: user.get('contractingShell') || user.get('unApprovedShellAccount') || false,
  selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
  userId: user.get('id'),
  billingPlan: user.get('billingPlan'),
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
});
import { triggerNoAccessWarning as triggerNoAccessWarningAction } from '../../../../middleware/accessCheckHelperFns';
import { openUpgradeFrom } from '../../../../stores/ui/components/upgrade/upgrade-actions';
const mapDispatchToProps = dispatch => ({
  triggerNoAccessWarning: (...args) => dispatch(triggerNoAccessWarningAction(...args)),
  openUpgradeFrom: () => dispatch(openUpgradeFrom('contractListSentStatus')),
});
export default connect(mapStateToProps, mapDispatchToProps)(ContractRow);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/list/contract-row.jsx